export function sanitizeFilenameInUrl(fileName) {
  // eslint-disable-next-line no-useless-escape
  return fileName.replace(/[^a-z0-9\.\-åäö]/ig, "_");
}
